import { BASE_URL } from '../config';
import axiosApiInstance from '../../interceptors/axiosApiInstance';

const QueuePoolService = {
    getQueuePool: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/queue-pool`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getMonitoringQuePool: async function (status, search) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/queue-pool/operations`, {
                params: {
                    status,
                    search
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQueuePoolOperationCount: async function (status, qpool_id, search_value) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/queue-pool/operation/count`, {
                params: {
                    status,
                    qpool_id,
                    search_value
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQueuePoolDetail: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/queue-pool/detail/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postQueuePool: async function (data) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/queue-pool`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    putQueuePool: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/queue-pool/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteQueuePool: async function (id) {
        try {
            const response = await axiosApiInstance.delete(await BASE_URL + `/queue-pool/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default QueuePoolService;
